import { InitialsAvatar } from './initials-avatar'

/**
 * Phase 7 — User Avatar slot. Renders the uploaded image when {@code avatarUrl} is set; falls
 * back to {@code InitialsAvatar} otherwise. Lazy-loaded — every chip below the fold defers
 * fetching until scroll.
 *
 * <p>Browser scales from the canonical 256×256 server output to the requested {@code size}; CSS
 * keeps it square via {@code object-cover}.
 */
interface AvatarImageProps {
  avatarUrl: string | null | undefined
  handle: string
  displayName: string
  size: number
}

export const AvatarImage = ({ avatarUrl, handle, displayName, size }: AvatarImageProps) => {
  if (!avatarUrl) {
    return <InitialsAvatar handle={handle} size={size} />
  }
  return (
    <img
      src={avatarUrl}
      alt={`Avatar for ${displayName}`}
      width={size}
      height={size}
      loading="lazy"
      className="inline-block shrink-0 rounded-full object-cover"
      style={{ width: size, height: size }}
    />
  )
}
